import { Box, useTheme } from '@material-ui/core';
import React from 'react';
import { animated } from 'react-spring';
import { DownloadAnalysisTheme } from '../../../../../graphql/projects/mutations/projects/useDownloadAnalysisGq';
import { formatNumber } from '../../../../../logic/otherUtilities/formatting/formatNumber';

export interface MarketDemandItemProps {
  label: string;
  number: any;
  icon: React.ComponentType<any>;
  description: string;
  bgColor: string;
  iconColor: string;
  slideTheme: DownloadAnalysisTheme;
}

export const MarketDemandItem: React.FC<MarketDemandItemProps> = ({
  label,
  number,
  icon,
  description,
  bgColor,
  iconColor,
  slideTheme,
}) => {
  const theme = useTheme();
  const Icon = icon;
  const fontFamilyClass = slideTheme === 'voxel' ? 'font-voxel-charts' : 'font-pixel-charts';
  return (
    <div className="flex flex-col items-center">
      <div
        className={`mb-4 font-medium ${fontFamilyClass} text-md text-center w-72 h-24 flex items-center justify-center`}
        style={{ color: theme.palette.text.primary }}
      >
        {description}
      </div>
      <div
        className={`
          h-[180px]
          w-[180px]
          rounded-full
          flex flex-col items-center justify-center
          p-4
          m-8
        `}
        style={{ backgroundColor: bgColor }}
      >
        <Icon fontSize="large" style={{ fontSize: 72, color: iconColor }} />
      </div>
      <div
        className={`font-semibold ${fontFamilyClass} text-3xl text-center mb-1`}
        style={{ color: theme.palette.primary.main }}
      >
        <animated.span>{number.to((val: number) => formatNumber(val, 0))}</animated.span>
      </div>
      <div
        className={`font-bold ${fontFamilyClass} text-xl text-center`}
        style={{ color: theme.palette.primary.main }}
      >
        {label}
      </div>
    </div>
  );
};

export default MarketDemandItem;
